import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent,
} from '@softline/dynamic';
import { FahrzeugverwendungsbestimmungListView } from './list-view/fahrzeugverwendungsbestimmung.list-view';

export const fahrzeugverwendungsbestimmungFieldOk: FieldOkConfig = {
  name: 'fahrzeugverwendungsbestimmung',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{verwendungsbestimmung}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: FahrzeugverwendungsbestimmungListView,
        sort: {
          properties: [{ property: 'objekt', title: 'Objekt' }],
        },
      },
    },
  ],
};
export const fahrzeugverwendungsbestimmungMultiselectFieldOk: FieldOkConfig = {
  name: 'fahrzeugverwendungsbestimmung',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{verwendungsbestimmung}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkMultiselectListViewComponent,
      title: 'Auswahl',
      config: {
        component: FahrzeugverwendungsbestimmungListView,
        sort: {
          properties: [{ property: 'objekt', title: 'Objekt' }],
        },
      },
    },
  ],
};

export const fahrzeugverwendungsbestimmungQueryFieldOk: FieldOkConfig = {
  name: 'fahrzeugverwendungsbestimmung',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{verwendungsbestimmung}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: QueryFieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: FahrzeugverwendungsbestimmungListView,
        sort: {
          properties: [{ property: 'objekt', title: 'Objekt' }],
        },
      },
    },
  ],
};
